import SubHeader from "../../components/SubHeader";
import ContactForm from "./ContactForm";
import ContactMap from "./ContactMap";
import React from "react";
export default function Contact(){
    const subheadData = {
      image: '../assets/images/contact-banner.webp',
      pagename: 'Contact us',
      subhead: 'Get in touch to discuss tailored commercial laundry solutions.',
    }

    return(
        <>
        <SubHeader subheadData={subheadData}/>
        <ContactForm/>
        <ContactMap/>
        </>
    )
}